import { useEffect, useState } from 'react';
import { FaPaintRoller, FaPaintBrush } from 'react-icons/fa';


export default function ConfigButton({ block, updateBlock, nodes, updateNode, node }) {
 
 

    if(block.destinationType == null){
        block.destinationType = 'step';
    }
    if(block.target == null){
        block.target = '';
    }
    if(block.animation == null){
        block.animation = false;
    }
    
    function handleTitleChange(e) {
        
        updateBlock(block.id, 'label', e.target.value);
     
    }
    // No local state or useEffect needed, input is always controlled by block.label
 

        function handleDestinationTypeChange(e) {
            updateBlock(block.id, 'destinationType', e.target.value);
            
        }

        function handleUrlChange(e) {
            updateBlock(block.id, 'url', e.target.value);
           
        }

        function handleColorChangeText(e) {
          
                updateBlock(block.id, 'textColor', e.target.value);
           
        }

        function handleColorChangeButton(e) {
            updateBlock(block.id, 'buttonColor', e.target.value);
        }

        function handleTargetChange(e) {
            updateBlock(block.id, 'target', e.target.value);
 
        }
        function goToStep(step) {
            console.log('step', step);
        }

        function handleButtonColorChange(e) {
            updateBlock(block.id, 'buttonColor', e.target.value);
        }

        function handleAnimationChange(e) {
            updateBlock(block.id, 'animation', e.target.value);
           
        }

    return (
        <div      
      
        >
            <label className="block font-semibold mb-2">Título do Botão:</label>
            <div className="p-2 bg-gray-100 rounded">
                <input type="text" className="w-full p-2 rounded"
                value={block.label}
                onChange={handleTitleChange}
              
                />
            </div>
            <div className="mt-4">
                <label className="block font-semibold mb-2">Destino:</label>
                <select
                    className="w-full p-2 rounded bg-gray-100"
                    value={block.destinationType}
                    onChange={handleDestinationTypeChange}
                >
                    <option value="step">Etapa</option>
                    <option value="url">URL Personalizada</option>
                </select>
                    {block.destinationType === "url" ? (
                        <div className="mt-2">
                            <label className="block font-semibold mb-2">URL:</label>
                            <input
                                type="text"
                                className="w-full p-2 rounded"
                                value={block.url}
                                onChange={handleUrlChange}
                                placeholder="https://exemplo.com"
                            />
                        </div>
                    ) : (
                        <div className="mt-2">
                            <label className="block font-semibold mb-2">Selecione a etapa destino:</label>
                            <select
                                className="w-full p-2 rounded bg-gray-100"
                                value={block.target}
                                onChange={handleTargetChange}
                            >
                                <option value="" disabled>Escolha uma etapa</option>
                                {(nodes || []).map(node => (
                                    <option key={node.id} value={node.id}>
                                        {node.data?.title || `${node.id}`}
                                    </option>
                                ))}
                            </select>
                        </div>
                    )}
                
            </div>
            <label className="block font-semibold mb-2">Cor do Texto:</label>
            {/* Preset and custom color picker for text color */}
            <div className="p-2 bg-gray-100 rounded mb-4">
                <div className="mb-2 flex flex-wrap gap-2">
                    {[
                        "#000000", "#FFFFFF", "#FF0000", "#00FF00", "#0000FF",
                        "#FFA500", "#FFFF00", "#00FFFF", "#FF00FF", "#808080"
                    ].map((preset, idx) => (
                        <button
                            key={idx}
                            type="button"
                            className="w-8 h-8 rounded-full border-2 border-white shadow"
                            style={{
                                backgroundColor: preset,
                                outline: block.color === preset ? '2px solid #2563eb' : 'none',
                                boxShadow: block.color === preset ? '0 0 0 2px #2563eb' : undefined,
                            }}
                            onClick={() => {
                                block.color = preset;
                               
                                document.getElementById(`button-${block.id}`).style.color = preset;
                            }}
                            aria-label={`Escolher cor ${preset}`}
                        />
                    ))}
                    {/* Custom color input */}
                    <label className="w-8 h-8 rounded border-2 border-blue-500 shadow flex items-center justify-center cursor-pointer relative">
                        <input
                            type="color"
                            className="absolute inset-0 opacity-0 cursor-pointer"
                            style={{ width: '100%', height: '100%' }}
                         
                            onChange={handleColorChangeText}
                        />
                        <div className="flex items-center justify-center absolute  right-[-40px] w-8 h-8 rounded-full border-2 border-white shadow"  style={{zIndex: 1000}}> 
                            <FaPaintBrush />
                        </div>
                        <span
                            className="w-6 h-6 rounded-full border"
                            style={{ backgroundColor: block.color, borderColor: '#ccc' }}
                        />
                    </label>
                </div>
            </div>
            <label className="block font-semibold mb-2">Cor do Botão:</label>
            {/* Preset and custom color picker for button background */}
            <div className="p-2 bg-gray-100 rounded">
                <select
                    className="w-full p-2 rounded bg-gray-100"
                    value={block.buttonColor}
                    onChange={handleButtonColorChange}
                >
                    <option value="theme">Tema</option>
                    <option value="blue">Azul</option> 
                    <option value="black">Preto</option>
                    <option value="white">Cinza</option>
                    <option value="red">Vermelho</option>
                    <option value="green">Verde</option>
                    <option value="pink">Rosa</option>
                    <option value="orange">Laranja</option>
                    <option value="purple">Roxo</option>
                </select>
            
              
            </div>   

            <label className="block font-semibold mb-2">Animação:</label>
            {/* Preset and custom color picker for button background */}
            <div className="p-2 bg-gray-100 rounded">
                <select
                    className="w-full p-2 rounded bg-gray-100"
                    value={block.animation}
                    onChange={handleAnimationChange}
                >
                    <option value="true">Ativado</option>
                    <option value="false">Desativado</option>
                </select>
            
              
            </div>   

           

        </div>
    );
}